import { createContext, useContext } from "react";

import { DEFAULT_ANIMATION_TIMER_API } from "../../components/animation-timeline/hooks";
import { DEFAULT_DRAW_TOOLBAR_API } from "../../components/draw-toolbar";
import { DEFAULT_FRAME_STENCILS_API } from "../../hooks/use-frame-stencils-api";
import { DEFAULT_PLAY_STATE_API } from "../../hooks/use-play-state-api";
import { DEFAULT_SELECT_ITEM_API } from "../../hooks/use-select-item-api";
import { PlayContextApi } from "./hooks/use-play-context-api";
import { DEFAULT_TOOL_PALETTE_API } from "./hooks/use-tool-palette-api";

export const PlayContext = createContext<PlayContextApi>({
  selectItemApi: DEFAULT_SELECT_ITEM_API,
  playStateApi: DEFAULT_PLAY_STATE_API,
  frameStencilsApi: DEFAULT_FRAME_STENCILS_API,
  animationTimerApi: DEFAULT_ANIMATION_TIMER_API,
  drawToolbarApi: DEFAULT_DRAW_TOOLBAR_API,
  toolPaletteApi: DEFAULT_TOOL_PALETTE_API,
});

export const usePlayContext = () => useContext(PlayContext);
